import { TicketStatesReceiving } from '../../../components/ticket/ticket.constants';
import _ from 'lodash';
import { InjectableClass } from '@fino/lib-injection';

export class DocumentSummaryController extends InjectableClass {
  constructor(
    controllerService,
    ticketService,
    fileResponseService,
    userService,
    $translate,
    sidebarService,
    $window,
    $scope,
    needsConfirmationService,
    $stateParams,
  ) {
    'ngInject';
    super({
      controllerService,
      ticketService,
      fileResponseService,
      userService,
      $translate,
      sidebarService,
      $window,
      $scope,
      needsConfirmationService,
      $stateParams,
    });
  }

  $onInit() {
    this.resendIsLoading = false;

    // Fix rejected balance list documents description
    _.forEach(this.documents, (doc) => {
      switch (doc.description) {
        case 'BALANCE_LIST': {
          if (doc.rejectionReason) {
            doc.description = 'REJECTED_BALANCE_LIST';
            break;
          }
        }
      }
    });

    this.registerBlankSepaDocumentToDocumentList();
    this.maybeRegisterAwesomeBalanceList();

    // Sort order of documents
    this.documents = _.sortBy(this.documents, ['preliminary']);
  }

  registerBlankSepaDocumentToDocumentList() {
    if (
      !this.ticketService.statusHistoryContains(
        this.ticket,
        TicketStatesReceiving.PAYMENT_PARTNER_INFORMATION_STARTED,
      )
    ) {
      // watch to ticket history if PAYMENT_PARTNER_INFORMATION_STARTED was added to update sidebar if status was added.
      this.$scope.$watch('vm.ticket.history.length', () => {
        // push blank sepa mandate update document to documents list.
        if (
          this.ticketService.statusHistoryContains(
            this.ticket,
            TicketStatesReceiving.PAYMENT_PARTNER_INFORMATION_STARTED,
          )
        ) {
          this.applyDocument();
        }
      });
    } else {
      this.applyDocument();
    }
  }

  applyDocument() {
    this.documents.push({
      description: 'blankSepa',
      preliminary: false,
      url: `/api/v0/aid/requests/${this.ticket.id}/documents/blankSepaMandateUpdate`,
    });
  }

  maybeRegisterAwesomeBalanceList() {
    if (!this.userService.isTestPilot()) {
      return;
    }

    if (this.documentsContainBalanceList()) {
      this.documents.push({
        description: 'awesomeBalanceList',
        url: `/api/v0/aid/requests/${this.ticket.id}/documents/awesomeBalanceList`,
      });
    }
  }

  documentsContainBalanceList() {
    return this.documents.some((x) => x.description === 'RENDERED_BALANCELIST');
  }

  download(file) {
    const { ticketService, fileResponseService } = this;
    const { url } = file;
    // documents with pdf extension should be opened in new tab
    const fileRegex = new RegExp('^http.*.pdf', 'g');
    if (fileRegex.test(url)) {
      const openedWindow = this.$window.open(url, '_blank');
      if (openedWindow) openedWindow.focus();
    } else {
      ticketService
        .downloadDocument(url)
        .busy(this, 'isDownloadBusy')
        .then((file) => fileResponseService.saveAs(file));
    }
  }

  resendDocument($event, file) {
    _.defaults(this.$scope, {
      confirmTitle: 'app.documentSummary.resend.confirm.title',
      confirmBody: 'app.documentSummary.resend.confirm.body',
      confirmOk: 'app.documentSummary.resend.confirm.ok',
    });

    this.needsConfirmationService.open({
      scope: this.$scope,
      onSuccess: () => this.executeResendDocument($event, file),
    });
  }

  executeResendDocument($event, file) {
    $event.stopPropagation();

    const { ticket, ticketService, sidebarService } = this;

    // Prevent double click
    if (this.resendIsLoading) {
      return;
    }

    sidebarService.showFlashMessage(
      'app.documentSummary.resend.isSending',
      'info',
    );

    ticketService
      .resendDocument(ticket.id, ticket.requestType, file)
      .busy(this, 'resendIsLoading')
      .then(() => {
        // add a comment in notes section
        this.ticketService
          .addComment(
            ticket.id,
            {
              text: this.$translate.instant(
                'app.documentSummary.resend.note.text',
              ),
            },
            this.$stateParams.product,
          )
          .then(() =>
            sidebarService.showFlashMessage(
              'app.documentSummary.resend.success',
              'success',
            ),
          );
      })
      .catch(() =>
        sidebarService.showFlashMessage(
          'app.documentSummary.resend.error',
          'error',
        ),
      );
  }
}
